
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSelect } from '@/components';
import { AppTable, AppSimpleTable, AppError, AppFileUpload } from '@/components';
import { usePromotionBoosterAdd, usePromotionModalProps } from '@/modules/promotion/booster/model/add';
import { Options as BoosterOptions } from '@/modules/booster/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { useCrudActions } from '@/common/view/useCrudActions';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.BOOSTER.ADD,
    components: {
        AppFormRow,
        AppInput,
        AppButton,
        AppCard,
        AppSelect,
        AppTable,
        AppSimpleTable,
        AppError,
        AppFileUpload
    },
    setup() {
        const { MODAL_NAME, promotionModel, promotionV$, modalActions } = usePromotionModalProps();
        const { v$, model, promotionOption, boosterOptionExcludeAdded, actions, fetchLinkableItems } =
            usePromotionBoosterAdd();

        const createAccessUnlimitedPromotion = useCrudActions().excuteAndNotify({
            validator: promotionV$,
            request: () => modalActions.createAccessUnlimitedPromotion(),
            onSuccess: async ({ data }) => {
                await fetchLinkableItems();
                model.promotionId = data;
                modalActions.closeModal();
            }
        });

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: BoosterOptions.ItemType },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: (evt: any) => {
                            evt.preventDefault();
                            actions.removeBoosterItem(row.type);
                        }
                    })
                }
            ]
        };

        return {
            v$,
            model,
            table,
            promotionOption,
            boosterOptionExcludeAdded,
            actions,
            MODAL_NAME,
            promotionModel,
            promotionV$,
            modalActions,
            createAccessUnlimitedPromotion
        };
    }
});
